var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_264_1",
    "data-name": "Component 264 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2, .cls-3 {\n        stroke: none;\n      }\n\n      .cls-3 {\n        fill: #dfdfdf;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_20837",
    "data-name": "Path 20837",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M 8 15.5 C 3.864490032196045 15.5 0.5 12.13551044464111 0.5 8 C 0.5 3.864490032196045 3.864490032196045 0.5 8 0.5 C 12.13551044464111 0.5 15.5 3.864490032196045 15.5 8 C 15.5 12.13551044464111 12.13551044464111 15.5 8 15.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M 8 1 C 4.140190124511719 1 1 4.140190124511719 1 8 C 1 11.85980987548828 4.140190124511719 15 8 15 C 11.85980987548828 15 15 11.85980987548828 15 8 C 15 4.140190124511719 11.85980987548828 1 8 1 M 8 0 C 12.41827964782715 0 16 3.581720352172852 16 8 C 16 12.41827964782715 12.41827964782715 16 8 16 C 3.581720352172852 16 0 12.41827964782715 0 8 C 0 3.581720352172852 3.581720352172852 0 8 0 Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20866",
    "data-name": "Path 20866",
    d: "M11.143,5.429H7.714V3.714a1.143,1.143,0,1,1,2.286,0h.571a1.714,1.714,0,1,0-3.429,0V5.429H6.571A.571.571,0,0,0,6,6V9.429A.571.571,0,0,0,6.571,10h4.571a.571.571,0,0,0,.571-.571V6A.571.571,0,0,0,11.143,5.429Z",
    transform: "translate(-0.857 2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockSymbol);
export default __webpack_public_path__ + "static/media/UnlockSymbol.88259f0e9387d309e9d15989c5499b9b.svg";
export { ForwardRef as ReactComponent };